export function parseQuery<T>(queryString: string): T {
    const params = {};
    const pairs = queryString.substr(1).split('&');
    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    }
    return params as T;
}
